import React from "react";
import stores from "@stores";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const useCurrentProject = () => {
  const { id: projectId } = useParams();

  const { projectsStore } = stores;
  const { currentProject, isLoading } = projectsStore;

  const fetchCurrentProject = async () => {
    await projectsStore.getCurrentProject(projectId);
  };

  const refresh = async () => {
    await projectsStore.getCurrentProject(projectId, true);
  };

  useEffect(() => {
    fetchCurrentProject();
  }, []);

  return {
    isLoading,
    currentProject,
    refresh,
  };
};

export default useCurrentProject;
